module.exports = __webpack_public_path__ + "static/media/BIM 360 Plan.ec61f7b3.png";